import { configureStore } from '@reduxjs/toolkit';
import usersReducer from './usersSlice';
import achievementsReducer from './achievementsSlice';
import activitiesReducer from './activitiesSlice';
import scoringReducer from './scoringSlice';
import menuReducer from './menuSlice';
import loginReducer from './loginSlice';
import themeReducer from './themeSlice';
import { fetchScoringData, fetchBadgesData } from './scoringSlice';

export const store = configureStore({
  reducer: {
    users: usersReducer,
    achievements: achievementsReducer,
    activities: activitiesReducer,
    scoring: scoringReducer,
    menu: menuReducer,
    login: loginReducer,
    theme: themeReducer,
  },
});

const initLoad = () => {
  
  store.dispatch(fetchScoringData());
  store.dispatch({ type: 'scoring/scoringLoading', payload: true });
  store.dispatch(fetchBadgesData());
  store.dispatch({ type: 'scoring/badgesLoading', payload: true });
};

initLoad();
